var map = {
	"./ic-announcement-hover.svg": "dc09",
	"./ic-devices-hover.svg": "afcc",
	"./ic-layouts-hover.svg": "fe03",
	"./ic-media-hover.svg": "336c",
	"./ic-playlists-hover.svg": "0312",
	"./ic-screens-hover.svg": "ca34",
	"./ic-smartplug-hover.svg": "a0db",
	"./ic-stats-hover.svg": "ccd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3715";